import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  GETTING_USER_RESIDENCY_INFO,
  CREATING_USER_RESIDENCY_INFO,
  PATCHING_USER_RESIDENCY_INFO,
  UPDATE_USER_RESIDENCY_INFO,
} from './actionTypes';

import { API_ENDPOINT } from '../constants';

import { residencyInfoMapping } from '../constants/Dashboard/Residency';

// CONFIRM RESIDENCY INFO MODAL
export const updateUserResidencyInfo = (dispatch, residencyInfo) => {
  dispatch({ type: UPDATE_USER_RESIDENCY_INFO, payload: residencyInfo });
};

export const getUserResidencyInfo = createAsyncThunk(
  GETTING_USER_RESIDENCY_INFO,
  async ({ id, tokenValue }, methods) => {
    const { dispatch } = methods;
    let response;
    try {
      const res = await axios.get(`${API_ENDPOINT}/users/${id}/residency`, {
        headers: {
          Authorization: `Bearer ${tokenValue}`,
        },
      });
      response = res?.data || {};
    } catch (error) {
      console.error(error);
    }
    const residencyInfoObj = {
      userAddressId: response.id,
      startDate: response.startDate,
    };

    Object.keys(residencyInfoMapping).forEach((label) => {
      if (label === 'tenantStatus' || label === 'monthlyPayment') {
        return (residencyInfoObj[residencyInfoMapping[label]] = response[label]);
      }

      return (residencyInfoObj[residencyInfoMapping[label]] = response.addressInfo[label]);
    });

    updateUserResidencyInfo(dispatch, residencyInfoObj);
  },
);

export const createUserResidencyInfo = createAsyncThunk(
  CREATING_USER_RESIDENCY_INFO,
  async ({ body, user, tokenValue }, methods) => {
    const { dispatch } = methods;
    let response = {};
    const addressObj = {};
    const userAddressObj = {};
    const residencyInfoObj = {};

    Object.keys(residencyInfoMapping).forEach((label) => {
      if (label === 'tenantStatus' || label === 'monthlyPayment') {
        return (userAddressObj[label] = body[residencyInfoMapping[label]] || 0);
      }

      if (label == 'How long have you lived here?') {
        return;
      }

      return (addressObj[label] = body[residencyInfoMapping[label]]);
    });

    try {
      const res = await axios.post(
        `${API_ENDPOINT}/user_addresses/new/`,
        {
          ...body,
          ...userAddressObj,
          usersId: user.id,
          address: addressObj,
        },
        {
          headers: {
            Authorization: `Bearer ${tokenValue}`,
          },
        },
      );
      response = res?.data || {};
      residencyInfoObj.userAddressId = response.id;

      Object.keys(residencyInfoMapping).forEach((label) => {
        if (label === 'tenantStatus' || label === 'monthlyPayment') {
          return (residencyInfoObj[residencyInfoMapping[label]] = response[label]);
        }
        return (residencyInfoObj[residencyInfoMapping[label]] = response.addressInfo[label]);
      });
    } catch (error) {
      console.error(error);
    }

    updateUserResidencyInfo(dispatch, residencyInfoObj);
  },
);

export const patchUserResidencyInfo = createAsyncThunk(
  PATCHING_USER_RESIDENCY_INFO,
  async ({ id, body, tokenValue }, methods) => {
    const { dispatch } = methods;
    let response = {};
    const addressObj = {};
    const userAddressObj = {};
    const residencyInfoObj = {};

    Object.keys(residencyInfoMapping).forEach((label) => {
      if (label === 'tenantStatus' || label === 'monthlyPayment') {
        return (userAddressObj[label] = body[residencyInfoMapping[label]] || 0);
      }

      if (label == 'How long have you lived here?') {
        return;
      }

      return (addressObj[label] = body[residencyInfoMapping[label]]);
    });

    try {
      const res = await axios.patch(
        `${API_ENDPOINT}/user_addresses/${id}/`,
        {
          ...body,
          ...userAddressObj,
          address: addressObj,
          model: 'user_address',
        },
        {
          headers: {
            Authorization: `Bearer ${tokenValue}`,
          },
        },
      );
      response = res?.data || {};
      residencyInfoObj.userAddressId = response.id;

      Object.keys(residencyInfoMapping).forEach((label) => {
        if (label === 'tenantStatus' || label === 'monthlyPayment') {
          return (residencyInfoObj[residencyInfoMapping[label]] = response[label]);
        }

        return (residencyInfoObj[residencyInfoMapping[label]] = response.addressInfo[label]);
      });
    } catch (error) {
      console.error(error);
    }

    updateUserResidencyInfo(dispatch, residencyInfoObj);
  },
);
